import { render, staticRenderFns } from "./PurchasesOrderViewAddInvoiceForm.vue?vue&type=template&id=b96f53b8&scoped=true"
import script from "./PurchasesOrderViewAddInvoiceForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewAddInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewAddInvoiceForm.vue?vue&type=style&index=0&id=b96f53b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96f53b8",
  null
  
)

export default component.exports